import { is, mapObjIndexed, propOr } from 'ramda'

export const getSmartSize = (value, options = {}, defaultValue) => {
  value = value || defaultValue

  if (is(String, value)) {
    value = propOr(value, value, options)
  }

  if (is(Number, value)) {
    return `${value}rem`
  }

  return value
}

export const applyStyle = (key, value, formattedValue) => {
  if (value === undefined || value === false) return ''
  return `${key}: ${formattedValue !== undefined ? formattedValue : value};`
}

export const getPageWidth = () => {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  )
}

export const getPageWidthName = () => {
  const pageWidth = getPageWidth()

  if (pageWidth >= 850) return 'lg'
  if (pageWidth < 850 && pageWidth >= 650) return 'md'
  return 'sm'
}

export const getAffectedSizes = size => {
  switch (size) {
    case 'sm':
      return ['sm', 'mdd']
    case 'md':
      return ['md', 'mdd', 'mdu']
    case 'lg':
      return ['lg', 'mdu']
    default:
      return [size]
  }
}

export const formatResponsiveProps = props => {
  const pageSize = getPageWidthName()
  if (props.__formattedForSize === pageSize) return props
  const affectedSizes = getAffectedSizes(pageSize)

  let formattedProps = { __formattedForSize: pageSize, ...props }

  Object.entries(props).forEach(([key, value]) => {
    if (!key.includes('_')) return value
    const [initialKey, propSize] = key.split('_')
    if (affectedSizes.includes(propSize)) {
      formattedProps[initialKey] = value
    }
  })

  return formattedProps
}
